import { render, staticRenderFns } from "./FichaChamados.vue?vue&type=template&id=aec5fca2&"
import script from "./FichaChamados.vue?vue&type=script&lang=js&"
export * from "./FichaChamados.vue?vue&type=script&lang=js&"
import style0 from "./FichaChamados.vue?vue&type=style&index=0&id=aec5fca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports